export const useGetTva = (): (price: number, tvaRate: number) => number => {

    return (price: number, tvaRate: number): number => {
        return +((price - price * 100 / (100 + tvaRate)).toFixed(2))
    }
}
